const trackingUtils = require('od-modules/utils/tracking.utils');
const tagManagement = require('od-modules/utils/tag_management.utils');
const userAccountError = require('od-modules/users/user_account_error');
const accountPreferencesManagerFactory = require('components/user_area/account_preferences_manager/js/main');
const xsellFindBookingFactory = require('components/cross_selling/find_booking/js/main');
const downloadAppBannerFactory = require('components/app_download/download_app_banner/js/main');
const createWidgetLoader = require('components-framework/widget/create_widget_loader');

Odigeo.Router.handlers.accountpreferences = function() {
    Odigeo.Router.navigate('user_area');
    const pageName = 'accountpreferences';
    const $page = $('#page');
    const $myInfoUserName = $('#myInfoUserName');
    const asyncWidgets = Odigeo.autoloadWidgetsAsync({
        getMembershipManager: ['membership-manager', 'membership_manager'],
        getUsersManager: ['users-manager', 'usersmanager'],
    });
    const widgetLoader = createWidgetLoader({
        accountPreferencesManager: ['account-preferences-manager', accountPreferencesManagerFactory],
        xsellFindBooking: ['my-trips-with-find-booking', xsellFindBookingFactory],
        downloadAppBanner: ['download-app-banner', downloadAppBannerFactory],
    });

    $page.removeClass().addClass(pageName);

    Odigeo.Router.eventController = $.extend(
        Odigeo.Router.eventController,
        Odigeo.Router.handlers.globalEventController,
        Odigeo.Router.handlers.userEventController,
    );
    Odigeo.Router.eventController = $.extend(true, Odigeo.Router.eventController, {
        globalEvents: {
            'global:onGetDataError': 'onGetDataError',
        },
        viewEvents: {
            'account-preferences-manager:changePageTitle': 'onChangePageTitle',
            'account-preferences-manager:submitUserRequest': 'onUserManagerRequest',
            'account-preferences-manager:cancelAccount': 'onUserManagerRequest',
            'account-preferences-manager:changePassword': 'onUserManagerRequest',
            'account-preferences-manager:clearChangePasswordFieldsHide': 'clearChangePasswordFields',
            'cancel-account:submitUserRequest': 'onUserManagerRequest',
            'membership-account-preferences:renderOk': 'onMembershipAccountPreferencesRendered',
            'users-manager:getAccountInfoOk': 'onGetAccountInfoOk',
            'users-manager:getAccountInfoWithError': 'onGetDataError',
            'users-manager:getAccountInfoError': 'onGetDataError',
            'users-manager:changePasswordOk': 'onAccountPreferencesRequest',
            'users-manager:changePasswordWithError': 'onAccountPreferencesRequest',
            'users-manager:changePasswordError': 'onAccountPreferencesRequest',
            'users-manager:cancelAccountOk': 'onAccountPreferencesRequest',
            'users-manager:cancelAccountError': 'onAccountPreferencesRequest',
            'users-manager:cancelAccountWithError': 'onAccountPreferencesRequest',
            'users-manager:getMyTripsOk': 'onGetMyTrips',
            'users-manager:logOutOk': 'onGoToHomePage',
            'prime-renewal-cancellation:refreshAccountInfo': 'onRefreshAccountInfo',
            'frontend-shell:refreshAccountInfo': 'onRefreshAccountInfo',
        },
        eventHandlers: {
            onGetDataError(data) {
                userAccountError.processError(data);
            },

            onGoToHomePage() {
                Odigeo.Utils.goToApplicationHome();
            },

            onAccountPreferencesRequest(data) {
                _accountPreferencesRequest(data);
            },

            onUserManagerRequest(data) {
                _userManagerRequest(data);
            },

            onChangePageTitle() {
                _changePageTitle();
            },

            onGetAccountInfoOk(data) {
                const {displayName} = data;
                $myInfoUserName.text(displayName || '');
                _accountPreferencesRequest(data);
            },

            clearChangePasswordFields(data) {
                widgetLoader.get('accountPreferencesManager').execute('clearChangePasswordFields', data);
            },

            onMembershipAccountPreferencesRendered() {
                _userManagerRequest({action: 'getMyTrips'});
            },

            onRefreshAccountInfo() {
                _userManagerRequest({action: 'getAccountInfo'});
            },

            onGetMyTrips() {
                widgetLoader.get('accountPreferencesManager').execute('refreshKeys');
            },
        },
    });

    Odigeo.Router.eventController.execute();

    const $personalAreaMenu = $('#personal_area_menu');
    const menu = Odigeo.UIElements.menu.enhanceMenu($personalAreaMenu);

    const _accountPreferencesRequest = (data) => {
        widgetLoader.get('accountPreferencesManager').execute(data.action, data);
        widgetLoader.get('downloadAppBanner').execute('trackEventCategory', 'my_area_account');
    };

    const _userManagerRequest = (data) => {
        asyncWidgets.getUsersManager().execute('submitUserRequest', data);
    };

    const _changePageTitle = () => {
        $personalAreaMenu.data('track-action', 'sidebar').data('track-category', 'my_area_account');
    };

    _changePageTitle('main');
    _userManagerRequest({action: 'getAccountInfo'});

    if (menu) {
        menu.trigger('changeSelectedMenu', $page.attr('class'));
        widgetLoader.get('xsellFindBooking').execute('emptyFindBookings');
    }

    // Analytics: virtual page tracking
    trackingUtils.trackPage('account/preferences', {
        funnel: false,
    });
    tagManagement.updateDatalayer();
};
